import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

import template from './landing-page-url-column.pug';

export class LandingPageUrlColumn extends ProjectionGridBaseColumn {
  constructor({
    deps = {
      adDisplayUrlService: null,
    },
    i18n,
  }) {
    super({
      name: 'LandingPageUrl',
      property: 'Opportunities/RejectedAd',
      title: i18n.getString('Details_View_Langding_Page_Url'),
      sortable: false,
      bodyClasses: ['landing-page-url-column'],
      colClasses: ['col-superLongText'],
      helpId: 'Pop_BA_Recommendations_ExpandedURL',
    });

    this.deps = deps;
    this.i18n = i18n;
  }

  template({ value: { UrlOrLandingPage } }) {
    const { i18n } = this;

    const ad = {
      landingPageUrl: UrlOrLandingPage,
    };

    return template({
      i18n,
      ad,
    });
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
